import { action } from 'typesafe-actions';
import ActionTypes from 'store/app/actionTypes';
import { Alert, SetUsernamePasswordPayload } from 'store/app/types';
import {
  Estacion,
  FechaMaximaPractica,
  FechaMinimaPractica,
  JornadaUsuario,
} from 'store/practicas/types';

// Reset reducer
export const resetState = () => action(ActionTypes.RESET_STATE);

export const resetCreatePracticeForm = () =>
  action(ActionTypes.RESET_CREATE_PRACTICE_FORM);

export const resetStartCreatePracticeForm = () =>
  action(ActionTypes.RESET_START_CREATE_PRACTICE_FORM);

export const resetCreatePracticeFormError = () =>
  action(ActionTypes.RESET_CREATE_PRACTICE_FORM_ERROR);

// Set reducer
export const setError = (payload: string) =>
  action(ActionTypes.SET_ERROR, payload);

export const setUsername = (payload: string) =>
  action(ActionTypes.SET_USERNAME, payload);

export const setPassword = (payload: string) =>
  action(ActionTypes.SET_PASSWORD, payload);

export const setUsernamePassword = (payload: SetUsernamePasswordPayload) =>
  action(ActionTypes.SET_USERNAME_PASSWORD, payload);

export const setDateMinSelected = (payload: FechaMinimaPractica) =>
  action(ActionTypes.SET_DATE_MIN_SELECTED, payload);

export const setDateMaxSelected = (payload: FechaMaximaPractica) =>
  action(ActionTypes.SET_DATE_MAX_SELECTED, payload);

export const setStatePracticeSelected = (payload: string) =>
  action(ActionTypes.SET_STATE_PRACTICE_SELECTED, payload);

export const setSelectedCourses = (payload: number[]) =>
  action(ActionTypes.SET_SELECTED_COURSES, payload);
export const resetSelectedCourses = () =>
  action(ActionTypes.RESET_SELECTED_COURSES);

export const setSelectedCourse = (payload: string) =>
  action(ActionTypes.SET_SELECTED_COURSE, payload);

export const setSelectedSocieties = (payload: string) =>
  action(ActionTypes.SET_SELECTED_SOCIETIES, payload);

export const setSelectedInstructors = (payload: string[]) =>
  action(ActionTypes.SET_SELECTED_INSTRUCTORS, payload);

export const setSelectedAlumno = (payload: string[]) =>
  action(ActionTypes.SET_SELECTED_ALUMNO, payload);
export const resetSelectedStudents = () =>
  action(ActionTypes.RESET_SELECTED_STUDENTS);

export const setProfileSelected = (payload: number) =>
  action(ActionTypes.SET_PROFILE_SELECTED, payload);

export const setSelectedProvince = (payload: string[]) =>
  action(ActionTypes.SET_SELECTED_PROVINCE, payload);

export const setPracticaAuditoriaSeleccionada = (payload: string) =>
  action(ActionTypes.SET_PRACTICA_AUDITORIA_SELECCIONADA, payload);

export const setPracticaReclamadaSeleccionada = (payload: string) =>
  action(ActionTypes.SET_PRACTICA_RECLAMADA_SELECCIONADA, payload);

export const setPracticaRechazadaSeleccionada = (payload: string) =>
  action(ActionTypes.SET_PRACTICA_RECHAZADA_SELECCIONADA, payload);

export const setPracticaValidadaSeleccionada = (payload: string) =>
  action(ActionTypes.SET_PRACTICA_VALIDADA_SELECCIONADA, payload);

export const setSelectedJourney = (payload: JornadaUsuario | null) =>
  action(ActionTypes.SET_JORNADA_SELECCIONADA, payload);

export const setStartDateTimeSelectedJourney = (payload: Date | null) =>
  action(ActionTypes.SET_START_DATE_TIME_SELECTED_JOURNEY, payload);
export const setStartTimeSelectedJourneyPristine = (payload: boolean) =>
  action(ActionTypes.SET_START_TIME_SELECTED_JOURNEY_PRISTINE, payload);

export const setDateStartJourneyHadChange = () =>
  action(ActionTypes.SET_DATE_START_JOURNEY_HAD_CHANGE);

export const setFinishDateTimeSelectedJourney = (payload: Date | null) =>
  action(ActionTypes.SET_FINISH_DATE_TIME_SELECTED_JOURNEY, payload);
export const setFinishTimeSelectedJourneyPristine = (payload: boolean) =>
  action(ActionTypes.SET_FINISH_TIME_SELECTED_JOURNEY_PRISTINE, payload);

export const setStartDateTimeSelectedPreparation = (payload: Date | null) =>
  action(ActionTypes.SET_START_DATE_TIME_SELECTED_PREPARATION, payload);
export const setStartTimeSelectedPreparationPristine = (payload: boolean) =>
  action(ActionTypes.SET_START_TIME_SELECTED_PREPARATION_PRISTINE, payload);

export const setStartDateTimeSelectedService = (payload: Date | null) =>
  action(ActionTypes.SET_START_DATE_TIME_SELECTED_SERVICE, payload);
export const setStartTimeSelectedServicePristine = (payload: boolean) =>
  action(ActionTypes.SET_START_TIME_SELECTED_SERVICE_PRISTINE, payload);

export const setFinishDateTimeSelectedService = (payload: Date | null) =>
  action(ActionTypes.SET_FINISH_DATE_TIME_SELECTED_SERVICE, payload);
export const setFinishTimeSelectedServicePristine = (payload: boolean) =>
  action(ActionTypes.SET_FINISH_TIME_SELECTED_SERVICE_PRISTINE, payload);

export const setHourService = (payload: string | null) =>
  action(ActionTypes.SET_FINISH_HOUR_SERVICE, payload);

export const setStationSelected = (payload: Estacion | null) =>
  action(ActionTypes.SET_STATION_SELECTED, payload);

export const setDestinySelected = (payload: Estacion | null) =>
  action(ActionTypes.SET_DESTINY_SELECTED, payload);

export const setCreationSelected = (payload: string) =>
  action(ActionTypes.SET_CREATION_SELECTED, payload);

export const setSelectedSchool = (payload: string) =>
  action(ActionTypes.SET_SELECTED_SCHOOL, payload);

export const setIdTypePracticeSelected = (payload: string) =>
  action(ActionTypes.SET_ID_TYPE_PRACTICE_SELECTED, payload);

export const setTypePracticeSelected = (payload: string) =>
  action(ActionTypes.SET_TYPE_PRACTICE_SELECTED, payload);

export const setDisposicionPracticeSelected = (payload: string) =>
  action(ActionTypes.SET_DISPOSICION_PRACTICE_SELECTED, payload);

export const setTypeServiceSelected = (payload: string) =>
  action(ActionTypes.SET_TYPE_SERVICE_SELECTED, payload);

export const setVehicleSelected = (payload: string) =>
  action(ActionTypes.SET_VEHICLE_SELECTED, payload);

export const setTrainSelected = (payload: string) =>
  action(ActionTypes.SET_TRAIN_SELECTED, payload);

export const setObservationsSelected = (payload: string) =>
  action(ActionTypes.SET_OBSERVATIONS_SELECTED, payload);

export const setTurnSelected = (payload: string) =>
  action(ActionTypes.SET_TURN_SELECTED, payload);

export const setStateType = (payload: string) =>
  action(ActionTypes.SET_STATE_TYPE, payload);

export const setPracticaEditar = (payload: string) =>
  action(ActionTypes.SET_PRACTICA_EDITAR, payload);

export const setIsAuditar = (payload: string) =>
  action(ActionTypes.SET_IS_AUDITAR, payload);

export const setMsgSubmit = (payload: string) =>
  action(ActionTypes.SET_MSG_SUBMIT, payload);

export const setModalDraftType = (payload: string) =>
  action(ActionTypes.SET_MODAL_DRAFT_TYPE, payload);

export const setPracticaCreada = (payload: string) =>
  action(ActionTypes.SET_PRACTICA_CREADA, payload);

export const setUserList = (payload: string) =>
  action(ActionTypes.SET_USER_LIST, payload);


export const setStartJourneySelectedError = (payload: string | null) =>
  action(ActionTypes.SET_START_JOURNEY_SELECTED_ERROR, payload);

export const setStartJourneySelectedErrorDraft = (payload: string | null) =>
  action(ActionTypes.SET_START_JOURNEY_SELECTED_ERROR_DRAFT, payload);

export const setFinishDateJourneySelectedError = (payload: string | null) =>
  action(ActionTypes.SET_FINISH_DATE_JOURNEY_SELECTED_ERROR, payload);

export const setFinishDateJourneySelectedErrorDraft = (
  payload: string | null
) => action(ActionTypes.SET_FINISH_DATE_JOURNEY_SELECTED_ERROR_DRAFT, payload);

export const setObservacionesInstructor = (payload: string) =>
  action(ActionTypes.SET_OBSERVACIONES_INSTRUCTOR, payload);

export const setObservacionesAlumno = (payload: string) =>
  action(ActionTypes.SET_OBSERVACIONES_ALUMNO, payload);

export const setAlert = (payload: Alert) =>
  action(ActionTypes.SET_ALERT, payload);

export const setLoading = (payload: boolean) =>
  action(ActionTypes.SET_LOADING, payload);

export const setFinishTimeJourneySelectedError = (payload: string | null) =>
  action(ActionTypes.SET_FINISH_TIME_JOURNEY_SELECTED_ERROR, payload);

export const setFinishTimeJourneySelectedErrorDraft = (
  payload: string | null
) => action(ActionTypes.SET_FINISH_TIME_JOURNEY_SELECTED_ERROR_DRAFT, payload);

export const setStartServiceSelectedError = (payload: string | null) =>
  action(ActionTypes.SET_START_SERVICE_SELECTED_ERROR, payload);

export const setStartPreparationSelectedError = (payload: string | null) =>
  action(ActionTypes.SET_START_PREPARATION_SELECTED_ERROR, payload);

export const setStartServiceSelectedErrorDraft = (payload: string | null) =>
  action(ActionTypes.SET_START_SERVICE_SELECTED_ERROR_DRAFT, payload);

export const setFinishDateServiceSelectedError = (payload: string | null) =>
  action(ActionTypes.SET_FINISH_DATE_SERVICE_SELECTED_ERROR, payload);

export const setFinishDateServiceSelectedErrorDraft = (
  payload: string | null
) => action(ActionTypes.SET_FINISH_DATE_SERVICE_SELECTED_ERROR_DRAFT, payload);

export const setFinishTimeServiceSelectedError = (payload: string | null) =>
  action(ActionTypes.SET_FINISH_TIME_SERVICE_SELECTED_ERROR, payload);

export const setFinishTimeServiceSelectedErrorDraft = (
  payload: string | null
) => action(ActionTypes.SET_FINISH_TIME_SERVICE_SELECTED_ERROR_DRAFT, payload);

export const resetSelectedServicesAndJourneys = () =>
  action(ActionTypes.RESET_SELECTED_SERVICES_AND_JOURNEYS);

// minutes
export const setMinutesPracticeSelected = (payload: number | null) =>
  action(ActionTypes.SET_MINUTES_PRACTICE_SELECTED, payload);
export const setMinutesPracticeSelectedError = (payload: string | null) =>
  action(ActionTypes.SET_MINUTES_PRACTICE_SELECTED_ERROR, payload);

export const setMinutesCESelected = (payload: number | null) =>
  action(ActionTypes.SET_MINUTES_CE_SELECTED, payload);

export const setMinutesPendingCESelected = (payload: number | null) =>
  action(ActionTypes.SET_MINUTES_PENDING_CE_SELECTED, payload);

export const setMinutesOtherSelected = (payload: number | null) =>
  action(ActionTypes.SET_MINUTES_OTHER_SELECTED, payload);

export const setMinutesPendingOtherSelected = (payload: number | null) =>
  action(ActionTypes.SET_MINUTES_PENDING_OTHER_SELECTED, payload);

export const setMinutesDraftSelected = (payload: number | null) =>
  action(ActionTypes.SET_MINUTES_DRAFT_SELECTED, payload);

export const setMinutesPreparationSelected = (payload: number | null) =>
  action(ActionTypes.SET_MINUTES_PREPARATION_SELECTED, payload);

// Modal init ext. alumn
export const getInfoUserProfile = () =>
  action(ActionTypes.GET_INFO_USER_PROFILE);

export const setInfoUserProfileStatus = (payload: string) =>
  action(ActionTypes.SET_INFO_USER_PROFILE_STATUS, payload);

export const postUpdateUltimoAviso = () =>
  action(ActionTypes.UPDATE_INFO_USER_PROFILE);

export const setPostUpdateUltimoAviso = (payload: string) =>
  action(ActionTypes.SET_UPDATE_INFO_USER_PROFILE, payload);

export const resetValidarPracticaRequest = () =>
  action(ActionTypes.RESET_VALIDAR_PRACTICA_REQUEST);